{
  "actions": {
    "create_tag": "Créer une étiquette"
  },
  "tags": {
    "tag": "Étiquette",
    "used": "Utilisé",
    "created_at": "Créé le",
    "actions": "Actions",
    "contacts": "Contacts",
    "companies": "Entreprises",
    "rename_tag": "renommer l'étiquette",
    "order_by": "Trier par",
    "delete_tag_confirm_title": "Êtes-vous sûr de vouloir supprimer cette étiquette ?",
    "delete_tags_confirm_title": "Êtes-vous sûr de vouloir supprimer ces Tags ?",
    "remove_tag": "supprimer l'étiquette",
    "delete_tags": "Supprimer les Tags",
    "bulk_remove_tag": "supprimer les Tags en masse",
    "tags_label": "Tags",
    "type_to_search": "Tapez pour rechercher des Tags",
    "tags_placeholder": "Tags",
    "tag_name_label": "Nom de l'étiquette *",
    "name_tag_placeholder": "Nommez l'étiquette",
    "name_required": "Veuillez saisir un nom",
    "tag_created": "Étiquette créée.",
    "tag_update_notice": "Cela peut prendre jusqu'à 30 minutes pour mettre à jour l'étiquette sur tous les contacts et entreprises.",
    "tag_removal_notice": "Cela peut prendre jusqu'à 30 minutes pour que l'étiquette soit supprimée de toutes les entreprises et contacts.",
    "tags_removal_notice": "Cela peut prendre jusqu'à 30 minutes pour que les Tags soient supprimées de toutes les entreprises et contacts."
  }
}
